import * as React from 'react';
import { Body1AccentedTypography, Button } from 'ui';
import { LinkButton } from '../button/prebuilts/link-button';

type Props = {
	disabled?: boolean;
	isLoading?: boolean;
	submit: string;
	onLinkClick?: (e: React.MouseEvent<HTMLElement>) => void;
	linkText?: string;
	linkButton?: string;
};

export const Footer: React.FC<Props> = ({ disabled, isLoading, submit, linkText, onLinkClick, linkButton }) => {
	return (
		<footer className="flex w-full flex-col gap-2" data-testid="auth-footer">
			<Button
				variant="primary"
				className="w-full rounded-2xl bg-brandHeader text-center"
				type="submit"
				disabled={disabled}
				isLoading={isLoading}
				data-testid="auth-footer-submit"
			>
				<Body1AccentedTypography>{submit}</Body1AccentedTypography>
			</Button>
			{onLinkClick && <LinkButton linkText={linkText!} buttonText={linkButton!} onClick={onLinkClick} />}
		</footer>
	);
};
